import React from 'react';
import classes from './TabsContainer.module.css';
import clsx from 'clsx';
const TabsContainer = ({ Tag = 'menu', className, children, tabsContent }) => {
  return (
    <>
      <Tag className={clsx(classes.tabContent, className)}>{tabsContent}</Tag>
      {children}
    </>
  );
};
export default TabsContainer;
